// app.service.js
import angular from 'angular';
import config from 'app/config';
import moment from "moment";
import 'moment-timezone';

class userService {

  constructor($http, $location, $state) {
    this.config = config;
    this.$http = $http;
    this.$location = $location;
    this.$state = $state;
    this.user = {};
    this.qParams = this.getQueryParamObject();
    this.email =  this.hasProperty(this.qParams, 'email') ?  this.qParams.email : false;
  }

  // Query Params : read alll the query param and retun as object
  getQueryParamObject() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
  }

  // Query Params by key: read all the query param and retun a requested qParam
  getQueryParam(key, dvalue ='') {
    return this.hasProperty(this.qParams, key) ?  this.qParams[key] : dvalue;
  }

  // Check key in object
  hasProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  // retutn key value from object
  getProperty(object, key) {
    return this.hasProperty(object, key) ? object[key] : "";
  }

  checkProperty(obj, property) {
    return this.hasProperty(obj, property) ? obj[property].value : "";
  }

  getUser(email) {
    return this.$http.get(config.api + 'hs/contact/'+ decodeURIComponent(email));
  }

  getRow(endpoint) {
    return this.$http.get(this.config.apiv3 + endpoint);
  }

  getUserByEmailOrToken() {
    var contact = this.hasProperty(this.qParams, 'email') ?  decodeURIComponent(this.qParams.email) : this.getCookie('hubspotutk');
    return this.$http.get(config.api + 'hs/contact/'+ contact);
  }

  mergeHSUser(form) {
    if(this.email) {
      form.email = this.email;
      this.getUser(this.email).then( (result) => {
        if(result.data.status == 'ok') {
          this.user = result.data.data;
          var properties = this.user.properties;
          var mrgprty = {'billToFirstName':'firstname','billToLastName':'lastname','billToAddress1':'address','billToCity':'city','billToState':'state','billToPostalCode':'zip','billToCountry':'country','billToDayPhone':'home_phone'}
          angular.forEach(mrgprty, (property, key) => {
            form[key] = this.hasProperty(properties, property) ? properties[property].value : "";
          });
        }
      })
    }
    return form;
  }

  prefillHSForm(target, preprop, properties) {
    preprop.forEach((property, key) => {
      var prefillelm = document.getElementById(target);
      if(property.includes(':')) {
        var its = property.split(':');
        property = its[1];
        var value = this.checkProperty(properties, property)
        switch(its[0]) {
          case 'textarea': {
            let textelm = prefillelm.querySelector('textarea[name="'+property+'"]');
            textelm.value = value;
            textelm.dispatchEvent(new Event('input', { bubbles: true }));
          }
          break;
          case 'radio': {
            let radelm = prefillelm.querySelectorAll('input[name="'+property+'"]');
            let radelmval = prefillelm.querySelector('input[value="'+value+'"]');
            radelmval.setAttribute("checked", 'checked');
            radelmval.click();
            radelmval.dispatchEvent(new Event('change'), { bubbles: true });
            radelmval.blur();
          }
          break;
          case 'checkbox': {
            let checkvalues = value.split(';').filter( e => e.trim().length > 0 && e.trim() != ";");
            checkvalues.forEach((cvalue, i) => {
              let checelm = prefillelm.querySelector('input[value="' + cvalue + '"]');
              checelm.setAttribute("checked", true);
              checelm.click();
              checelm.dispatchEvent(new Event('click'), { bubbles: true });
              checelm.blur();
            });
          }
          break;
          case 'select': {
            let selelm  = prefillelm.querySelector('select[name="'+property+'"]');
            selelm.value = value;
            selelm.focus();
            selelm.dispatchEvent(new Event('input', { bubbles: true }));
            selelm.blur();
          }
          break;
          default:
        }
      } else {
        let telm = prefillelm.querySelector('input[name="'+property+'"]');
        telm.setAttribute("value", this.checkProperty(properties, property));
        telm.value = this.checkProperty(properties, property);
        telm.select();
        telm.dispatchEvent(new Event('input', { bubbles: true }));
        telm.blur();
      }
    })
  }

  onSubmitFill(form, properties, webinar) {
    angular.forEach(properties, (item, key) => {
      var value = '';
      switch(item.param) {
        case 'AFFID':
        value = this.qParams.AFFID ? this.qParams.AFFID : '';
        break;
        case 'fb':
        value = this.qParams.fb ? this.qParams.fb : '';
        break;
        case 'webinarkey':
        value = webinar.webinarkey;
        break;
        case 'webinarid':
        value = webinar.webinarid;
        break;
        case 'webinarurl':
        value = 'https://attendee.gotowebinar.com/register/'+webinar.webinarkey;
        break;
        default:
        value = '';
      }
      if(value) {
        //$(form).find('input[name="'+item.property+'"]').val(value).change();
      }
    });
  }

  saveHSProperty(email, data) {
    return this.$http.put(config.api + 'hs/contact/' + email, data);
  }

  saveHSForm(form, fields, title = "") {
    var hs_context = {hutk: this.getCookie('hubspotutk'), pageUrl:this.$location.absUrl().split('?')[0], pageName:title};
    var data = {fields:fields, hs_context:hs_context};
    return this.$http.post(config.api + 'hs/form/' + form, data);
  }

  // set cookie in browser
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    return true;
  }

  /**
  * Get the value of a cookie
  * @param  {String} name  The name of the cookie
  * @return {String}       The cookie value
  */
  getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // get current date and time on New_York time zone
  getNow(format = 'YYYY-MM-DD') {
    let now = moment().tz('America/New_York').utc();
    return moment(now).startOf('day').valueOf();
  }

  // check date isAFter from now
  isAfter(date, tz='America/New_York') {
    var now = moment().tz(tz);
    var fdate = moment.tz(date, tz);
    return now.isAfter(fdate);
  }


  // check date isBefore from now
  isBefore(date, tz='America/New_York') {
    var now = moment().tz(tz);
    var fdate = moment.tz(date, tz);
    return now.isBefore(fdate);
  }

}

userService.$inject = ["$http", "$location", "$state"];
export { userService }
